import React from "react"
import "./simpleSection.css"
export const SimpleSection = ({ children }) => {
    return <div className="simple-section">{children}</div>
}